// extracted by mini-css-extract-plugin
export var calendarView = "_mc-0";